const getConnectorText = (match) => match === 'all' ? 'AND' : 'OR';

const getOppositeMatch = (match) => match === 'all' ? 'any' : 'all';

const cloneConnector = (templateId, match) => {
    const connector = document.getElementById(templateId).content.cloneNode(true);

    connector.querySelector('.connector-tag-label').textContent = getConnectorText(match);

    return connector;
};

const getHeadingText = (match) => {
    const template = document.getElementById('filter-group-template');
    const heading  = template?.content.querySelector('.filter-group-heading');

    if (!heading) {
        return match === 'all' ? 'Check if all of the following match' : 'Check if any of the following match';
    }

    return heading.dataset[match] || heading.textContent.trim();
};

export const updateGroupState = (filterGroup) => {
    const heading = filterGroup.querySelector('.filter-group-heading');
    const match   = filterGroup.dataset.match;

    if (heading) {
        heading.innerHTML = heading.dataset[match] || getHeadingText(match);
    }
};

const updateConnectorTags = (container, selector, match) => {
    container.querySelectorAll(`${selector} .connector-tag`).forEach(tag => {
        tag.classList.add('connector-tag-flip');

        setTimeout(() => {
            tag.querySelector('.connector-tag-label').textContent = getConnectorText(match);
            tag.classList.remove('connector-tag-flip');
        }, 200);
    });
};

const ensureGroupConnectors = (configuration) => {
    const groups = configuration.querySelectorAll(':scope > .filter-group');

    configuration.querySelectorAll(':scope > .filter-group-connector').forEach(c => c.remove());

    groups.forEach((group, index) => {
        if (index === 0) {
            return;
        }

        group.before(cloneConnector('group-connector-template', configuration.dataset.match));
    });
};

const updateAddGroupButtonText = (button, configuration) => {
    const span       = button.querySelector('span');
    const groupCount = configuration.querySelectorAll('.filter-group').length;

    if (!span) {
        return;
    }

    span.textContent = groupCount > 0
        ? button.dataset.groupText
        : button.dataset.emptyText
    ;
};

const updateAllAddGroupButtonText = (configuration) => {
    configuration.closest('form')
        ?.querySelectorAll('button.add-filter-group')
        .forEach((button) => updateAddGroupButtonText(button, configuration));
};

document.addEventListener('click', (event) => {
    const target = event.target.closest('button.add-filter-group');

    if (!target) {
        return;
    }

    const configuration = target.closest('form')?.querySelector('.filter-configuration');

    if (!configuration) {
        return;
    }

    requestAnimationFrame(() => {
        const groupTemplate  = document.getElementById('filter-group-template');
        const filterTemplate = document.getElementById('automation-filter-template');

        const group  = groupTemplate.content.cloneNode(true);
        const filter = filterTemplate.content.cloneNode(true);

        group.querySelector('.filter-group-filters').appendChild(filter);

        configuration.appendChild(group);

        ensureGroupConnectors(configuration);
        updateAllAddGroupButtonText(configuration);

        const newGroup = configuration.querySelector('.filter-group:last-child');

        document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('automationfilteradded', {
            detail: {
                action:   newGroup.querySelector('.automation-filter:last-child'),
                newGroup: true,
            },
        }));
    });
});

document.addEventListener('click', (event) => {
    const target = event.target.closest('.filter-group button.add-filter');

    if (!target) {
        return;
    }

    const filterGroup = target.closest('.filter-group');

    requestAnimationFrame(() => {
        const container = filterGroup.querySelector('.filter-group-filters');
        const template  = document.getElementById('automation-filter-template');
        const filter    = template.content.cloneNode(true);

        if (container.querySelector('.automation-filter')) {
            container.appendChild(cloneConnector('filter-connector-template', filterGroup.dataset.match));
        }

        container.appendChild(filter);

        updateGroupState(filterGroup);

        document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('automationfilteradded', {
            detail: {
                action: container.querySelector('.automation-filter:last-child'),
            },
        }));
    });
});

document.addEventListener('click', (event) => {
    const filterGroup = event.target.closest('.filter-connector .connector-tag')?.closest('.filter-group');

    if (!filterGroup) {
        return;
    }

    const newMatch = getOppositeMatch(filterGroup.dataset.match);

    filterGroup.dataset.match = newMatch;

    updateConnectorTags(
        filterGroup.querySelector('.filter-group-filters'),
        '.filter-connector',
        newMatch,
    );

    updateGroupState(filterGroup);

    const configuration = filterGroup.closest('.filter-configuration');
    const groupIndex    = [...configuration.querySelectorAll('.filter-group')].indexOf(filterGroup);

    document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('filtermatchchanged', {
        detail: { scope: 'group', groupIndex },
    }));
});

document.addEventListener('click', (event) => {
    const configuration = event.target.closest('.filter-group-connector .connector-tag')?.closest('.filter-configuration');

    if (!configuration) {
        return;
    }

    const newMatch = getOppositeMatch(configuration.dataset.match);

    configuration.dataset.match = newMatch;

    updateConnectorTags(configuration, ':scope > .filter-group-connector', newMatch);

    document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('filtermatchchanged', {
        detail: { scope: 'configuration' },
    }));
});

document.addEventListener('click', (event) => {
    const target = event.target.closest('.remove-group');

    if (!target) {
        return;
    }

    const filterGroup   = target.closest('.filter-group');
    const configuration = filterGroup.closest('.filter-configuration');
    const groupIndex    = [...configuration.querySelectorAll('.filter-group')].indexOf(filterGroup);

    requestAnimationFrame(() => {
        filterGroup.remove();
        ensureGroupConnectors(configuration);
        updateAllAddGroupButtonText(configuration);

        document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('filtergroupremoved', {
            detail: { groupIndex },
        }));
    });
});

const rebuildFilterConnectors = (filterGroup) => {
    const container = filterGroup.querySelector('.filter-group-filters');
    const match     = filterGroup.dataset.match;

    container.querySelectorAll('.filter-connector').forEach(c => c.remove());

    const filters = container.querySelectorAll('.automation-filter');

    filters.forEach((filter, index) => {
        if (index === 0) {
            return;
        }

        filter.before(cloneConnector('filter-connector-template', match));
    });
};

document.addEventListener('sortabledrop', (event) => {
    const filterGroup = event.target.closest('.filter-group');

    if (!filterGroup) {
        return;
    }

    rebuildFilterConnectors(filterGroup);
    updateGroupState(filterGroup);

    const sourceContainer = event.detail.sourceContainer;
    const destinationContainer = event.detail.destinationContainer;

    if (sourceContainer && destinationContainer && sourceContainer !== destinationContainer) {
        const sourceGroup = sourceContainer.closest('.filter-group');

        if (sourceGroup) {
            rebuildFilterConnectors(sourceGroup);
            updateGroupState(sourceGroup);
        }
    }
});

